import {useLocation} from "react-router-dom";

const RequireAuth = ({ children }) => {
    let location = useLocation();
    //return <Navigate to="/error/403" state={{ from: location }} replace />;
    return children;
}

export default RequireAuth
